<smrts-page [tabTitle]="tituloPagina">

  <div header class="header-container">

    <h1 class="primary-color page-title">{{ tituloPagina }}</h1>

    <button mat-icon-button matTooltip="Voltar" class="accent-color" (click)="voltar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>

    <button mat-flat-button class="white-text-button btn-salvar" (click)="salvar()" [disabled]="salvando">
      {{ salvando ? 'Salvando...' : 'Salvar' }}
    </button>

  </div>

  @if (modelo) {
    <div class="content">
      <mat-card class="main-card">
        <div class="linha-nome-modelo">
          <p-floatLabel variant="on" class="nome-modelo-campo">
            <input pInputText id="nomeModelo" class="input-full-width" [(ngModel)]="modelo.nome" />
            <label for="nomeModelo">Nome do modelo</label>
          </p-floatLabel>
          <button mat-stroked-button class="btn-template" (click)="templateClick()">
            <i class="pi pi-code"></i> Template do laudo
          </button>
        </div>
        <p-tabs value="0" class="tabs-modelo">
          <p-tablist>
            <p-tab value="0">
              Itens de Vistoria
              <i class="pi pi-info-circle info-icon accent-color"
              pTooltip="Opções de itens que serão inspecionados em cada cômodo (ex: Piso, Porta). Itens fora do modelo também podem ser criados durante a vistoria."></i>
            </p-tab>
            <p-tab value="1">
              Cômodos Padrão
              <i class="pi pi-info-circle info-icon accent-color"
              pTooltip="Cômodos que se espera encontrar no imóvel, cada um com os itens de vistoria esperados nele. Na vistoria, itens fora da lista podem ser incluídos do modelo ou criados na hora, e cômodos com outros nomes também podem ser adicionados."></i>
            </p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              <app-itens-modelo-vistoria
                [itens]="modelo.itens"
                (itensChange)="modelo.itens = $event"
                (itemRemovido)="comodosTab.removerVinculosDoItem($event)">
              </app-itens-modelo-vistoria>
            </p-tabpanel>
            <p-tabpanel value="1">
              <app-comodos-modelo-vistoria #comodosTab
                [comodos]="modelo.comodos"
                [itensDoModelo]="modelo.itens"
                (comodosChange)="modelo.comodos = $event">
              </app-comodos-modelo-vistoria>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </mat-card>
    </div>
  }

</smrts-page>
